<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("announcement.new") }}</span>
      </h2>

      <!-- form input start-->
      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('common.name')"
      />

      <h6 class="mt-3">{{ $t("product.text") }}</h6>
      <select class="form-control " v-model="form.product">
        <option v-for="item in accessableProducts" :key="item" :value="item">{{ item }}</option>
      </select>

      <h6 class="mt-3">{{ $t("announcement.date") }}</h6>
      <date-picker
        v-model="form.dueDate"
        value-type="date"
        :disabled-date="disableFutureDates"
        :first-day-of-week="1"
        lang="tr"
        format="DD.MM.YYYY"
        placeholder="Örn: 21.11.2020"
      />

      <h6 class="mt-3">{{ $t("announcement.detail") }}</h6>
      <ckeditor v-model="form.detail" :editor="editor" />

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";

const state = "organizationAnnouncement";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  components: {
    DatePicker,
    ckeditor: CKEditor.component,
    DatePicker,
  },
  data() {
    return {
      form: {
        name: undefined,
        product: undefined,
        dueDate: undefined,
        detail: undefined,
      },
      formError: undefined,
      editor: ClassicEditor,
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      product: {
        required,
      },
      dueDate: {
        required,
      },
      detail: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) {
          this.form = {};
        } else {
          const prepared = { ...this.prepareFormForEdit(v, ["detail"]) };
          // DatePicker expects a Date instance
          if (prepared.dueDate) {
            prepared.dueDate = new Date(prepared.dueDate);
          }
          this.form = prepared;
        }
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    disableFutureDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const isUpdaterequest = this.isEditMode;
        const { data } = await this.$store.dispatch(`${state}/save`, this.form);

        this.$toast.success(this.$t("common.success"));

        if (this.closeOnSave || isUpdaterequest) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-announcement");
        }
        this.form = {};
        setTimeout(() => this.$emit("onSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
